import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TrackerModal from "./Tracker_Modal";
import ExportModal from "./Export";
import RemainderModal from "./Remainder";
import CreateNotesModal from "../Tracker_Andropause/Andropause_CreateNotes";
import trackerConfig from "./TrackerConfig.json";
import VitalsModal from "../Tracker_Pregnancy/VitalsModal";
import TrendGraph from "../Tracker_Pregnancy/Pregnancy_Trends";
import { useTranslation } from 'react-i18next';
const TrackerButtons = ({
  isPastDate,
  isToday,
  isFutureDate,
  showEditCycle,
  showTrends,
  trackerType,
  startDate,
  endDate,
  selectedDate,
  onCloseModalCallback, // Callback to refresh data on modal close
  isEditMode, // Added isEditMode prop
  onMiraClick, // <-- Add this prop
  miraConsent
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isRemainderModalOpen, setIsRemainderModalOpen] = useState(false);
  const [isCreateNotesModalOpen, setIsCreateNotesModalOpen] = useState(false);
  const [isSeeVitalModalOpen, setIsSeeVitalModalOpen] = useState(false);
  const [isSeeTrednsModalOpen, setIsSeeTrendsModalOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const handleEditCycleClick = () => setIsModalOpen(true);
  const handleOpenExportModal = () => setIsExportModalOpen(true);
  const handleCloseExportModal = () => setIsExportModalOpen(false);
  
  const handleOpenVitalClick = () => {
    setIsSeeVitalModalOpen(true); // Corrected the function call
  };
 
  const handleCloseVitalClick = () => {
    setIsSeeVitalModalOpen(false);
    onCloseModalCallback(); // Refresh on close
  };

  const handleOpenTrendsClick = () => {
    navigate("/graph")
  };
  const handleRedirectTrendsClick=()=>{
    navigate("/fertility-trends")
  }
  const handleLogMetrixClick = () => {
    debugger
    navigate("/fertility-health-log-metrics")
  };

  const handleOpenRemainderModal = () => {
    setIsRemainderModalOpen(true);
  };
  const handleCloseRemainderModal = () => {
    setIsRemainderModalOpen(false);
    onCloseModalCallback(); // Refresh on close
  };

  const handleOpenCreateNotesModal = () => setIsCreateNotesModalOpen(true);
  const handleCloseCreateNotesModal = () => {
    setIsCreateNotesModalOpen(false);
    onCloseModalCallback(); // Refresh on close
  };

  //const closeModal = () => setIsModalOpen(false);
  const closeModal = () => {
    setIsModalOpen(false);
    onCloseModalCallback(); // Ensure data refresh after modal close
};

  return (
    <>
      {!isToday && isPastDate && (
        <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleOpenCreateNotesModal}>
         {t("CreateNotesbtn")}
        </button>
      )}
      {isToday && (
        <>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2 text-nowrap" onClick={handleOpenRemainderModal}>
           {t("SetaReminderbtn")}
          </button>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleOpenCreateNotesModal}>
          {t("CreateNotesbtn")}
          </button>
        </>
      )}
      {isFutureDate && (
        <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2 text-nowrap" onClick={handleOpenRemainderModal}>
         {t("SetaReminderbtn")}
        </button>
      )}

      {showEditCycle && (
        <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleEditCycleClick}>
         {t("EditCycleData")}
        </button>
      )}
      {trackerType === "fertility" && miraConsent?.Consent !== "O" &&  (
        <>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2"  onClick={handleRedirectTrendsClick}>
            {t("SeeTrends")}
          </button>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleLogMetrixClick}>
            {t("loghealthmetric")}
          </button>
        </>
      )}

      {showTrends && (
        <>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleOpenVitalClick}>
          {t("EnterVitals")}
          </button>
          <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2" onClick={handleOpenTrendsClick}>
          {t("SeeTrends")}
          </button>
        </>
      )}
       <button className="win-btn-primary mobile-view mt-3 mt-md-0 me-md-2 exp" onClick={handleOpenExportModal}>
       {t("ExportData")}
      </button>
      <button className="win-btn-primary success mobile-view mt-3 mt-md-0 me-md-2" onClick={onMiraClick} >
        {t("mymira")}
      </button>

      <TrackerModal isOpen={isModalOpen} onClose={closeModal} trackerType={trackerType} isEditMode={isEditMode} /> {/* Passed isEditMode prop */}
      <ExportModal
        isOpen={isExportModalOpen}
        onClose={handleCloseExportModal}
        startDate={startDate}
        endDate={endDate}
        trackerType={trackerType}
        onExport={(start, end) => {
          console.log(`Exporting data from ${start} to ${end}`);
          handleCloseExportModal();
        }}
      />
      <RemainderModal
        isOpen={isRemainderModalOpen}
        onClose={handleCloseRemainderModal}
        selectedDate={selectedDate}
      />
      {/* {(trackerType === "Andropause") && ( */}
        <CreateNotesModal
          isOpen={isCreateNotesModalOpen}
          onClose={handleCloseCreateNotesModal}
          trackerType={trackerType}
          trackerConfig={trackerConfig[trackerType]}
          selectedDate={selectedDate}
        />
      {/* )} */}
      {(trackerType === "pregnancy") && (
        <VitalsModal
          isOpen={isSeeVitalModalOpen}
          onClose={handleCloseVitalClick}
          trackerType={trackerType}
        />
      )}
    </>
  );
};

export default TrackerButtons;
